import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { TennisBall, EnvelopeSimple, CaretLeft } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email, base_url: window.location.origin });
      setSent(true);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-bg min-h-screen flex items-center justify-center px-4 py-10" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-md bg-[#dfff00] flex items-center justify-center">
            <TennisBall size={22} weight="duotone" color="#09090b" />
          </div>
          <div className="font-heading uppercase tracking-tight text-2xl leading-none flex items-baseline">
            <span className="text-white">courtside</span><span className="text-[#dfff00] ml-0.5">OS</span>
          </div>
        </div>

        <div className="surface p-7">
          <h1 className="font-heading uppercase text-3xl mb-1">Forgot password</h1>
          {sent ? (
            <div data-testid="forgot-success">
              <div className="flex items-start gap-3 mt-4 bg-[#16ec06]/10 border border-[#16ec06]/30 rounded-md p-4">
                <EnvelopeSimple size={20} weight="bold" className="text-[#16ec06] mt-0.5 shrink-0" />
                <p className="text-sm text-zinc-300">
                  If an account exists for <span className="font-semibold text-white">{email}</span>, we&apos;ve emailed a
                  reset link. It expires in 1 hour — check your spam folder too.
                </p>
              </div>
              <Link to="/login" className="btn-ghost mt-5 inline-flex items-center gap-1.5" data-testid="back-to-login">
                <CaretLeft size={14} weight="bold" /> Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <p className="text-zinc-400 text-sm mb-6">
                Enter your account email and we&apos;ll send you a link to choose a new password.
              </p>
              <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
                <div>
                  <label className="font-label block mb-1.5">Email</label>
                  <input
                    type="email"
                    required
                    className="input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.replace(/\s+/g, ""))}
                    data-testid="forgot-email"
                    autoComplete="email"
                  />
                </div>
                {err && <div className="text-sm text-[#ff0026] bg-[#ff0026]/10 border border-[#ff0026]/30 rounded-md p-3" data-testid="forgot-error">{err}</div>}
                <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="forgot-submit">
                  {busy ? "Sending…" : "Send reset link"}
                </button>
              </form>
              <Link to="/login" className="btn-ghost mt-4 inline-flex items-center gap-1.5 text-xs" data-testid="back-to-login">
                <CaretLeft size={13} weight="bold" /> Back to sign in
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
